import { React, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./header.css";
import MenuIcon from "assets/images/burger-menu.svg";
import MenuIconDark from "assets/images/burger-menu-dark.svg";
import { useTheme } from "../../context/ThemeContext";
import ThemeToggle from "../ThemeToggle";
import LanguageToggle from "../LanguageToggle";

const Header = () => {
  const { t } = useTranslation();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isExperienceHovered, setExperienceHovered] = useState(false);
  // const [isDarkMode, setIsDarkMode] = useState(false);
  const sidebarRef = useRef();
  const sidebarRefList = useRef();
  const { isDarkMode } = useTheme();
  const handleMobileMenu = () => {
    // console.log("Mobile Menu Clicked");
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleClickOutside = (event) => {
    if (
      sidebarRef.current &&
      !sidebarRef.current.contains(event.target) &&
      sidebarRefList.current &&
      !sidebarRefList.current.contains(event.target)
    ) {
      setMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileMenuOpen]);

  const closeMenuBar = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div>
      {isMobileMenuOpen && <div className="menu-overlay" onClick={handleMobileMenu}></div>}
      <header className="header" id="header">
        {/* <img src={logo} alt="Website Logo" /> */}
        <Link to="/">
          <h1>Vincent.</h1>
        </Link>
        <div className="navigation">
          <Link to="/">{t("header.home")}</Link>
          <Link to="/about">{t("header.about")}</Link>
          {/* Experience Dropdown */}
          <div
            className="dropdown-container"
            onMouseEnter={() => setExperienceHovered(true)}
            onMouseLeave={() => setExperienceHovered(false)}>
            <span className="dropdown-header">{t("header.experience")}</span>
            <div
              className={`dropdown-menu ${
                isExperienceHovered ? "visible" : ""
              }`}>
              <Link to="/experience/professional">
                {t("header.experienceProfessional")}
              </Link>
              <Link to="/experience/other">{t("header.experienceOther")}</Link>
            </div>
          </div>
          {/* <Link to="/experience">Experience</Link> */}
          {/* <Link to="/experience">Other</Link> */}
          <Link to="/education">{t("header.education")}</Link>
          {/* <Link to="/projects">Projects</Link> */}

          {/* <Link to="/skills">Tools & Skills</Link> */}

          <Link to="/gallery">{t("header.gallery")}</Link>
          <Link to="/contact">{t("header.contact")}</Link>
          <LanguageToggle />
          <ThemeToggle />
        </div>
        <div ref={sidebarRef} className="menu-icon" onClick={handleMobileMenu}>
          <img src={isDarkMode ? MenuIcon : MenuIconDark} alt="Menu Icon" />
        </div>
      </header>
      <nav
        ref={sidebarRefList}
        className={`navigation-mobile ${isMobileMenuOpen ? "open" : ""}`}>
        <ul>
          <li className="mobile-theme-toggle">
            <LanguageToggle />
            <ThemeToggle />
          </li>
          <li onClick={closeMenuBar}>
            <Link to="/">{t("header.home")}</Link>
          </li>

          <li onClick={closeMenuBar}>
            <Link to="/about">{t("header.about")}</Link>
          </li>

          {/* <li onClick={closeMenuBar}>
            <Link to="/experience">Experience</Link>
          </li> */}
          {/* <li className="mobile-dropdown"> */}
          {/* <span onClick={() => setMobileDropdownOpen(!isMobileDropdownOpen)}>
              Experience
            </span> */}
          {/* <ul className={`submenu ${isMobileDropdownOpen ? "open" : ""}`}> */}
          <li onClick={closeMenuBar}>
            <Link to="/experience/professional">
              {t("header.experienceProfessional")}
            </Link>
          </li>
          <li onClick={closeMenuBar}>
            <Link to="/experience/other">{t("header.experienceOther")}</Link>
          </li>
          <li onClick={closeMenuBar}>
            <Link to="/education">{t("header.education")}</Link>
          </li>
          <li onClick={closeMenuBar}>
            <Link to="/gallery">{t("header.gallery")}</Link>
          </li>
          <li onClick={closeMenuBar}>
            <Link to="/contact">{t("header.contact")}</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Header;
